import { SYSTEM } from "../../../configs";

/**
 * Prediction model service URLs
 */

const DASH_BACKEND_BASE_URL = SYSTEM.DASHBOARD_BACKEND_BASE_URL;
const PLATFORM_BASE_URL = SYSTEM.PLATFORM_BACKEND_BASE_URL;

export const MODEL_SERVICE_URLS = {
  MACHINE_FE_STATUS:
    DASH_BACKEND_BASE_URL + "/api/geslub_dash/v1/machine_fe_status/prediction",

  MACHINE_FE_STATUS_INFO:
    DASH_BACKEND_BASE_URL + "/api/geslub_dash/v1/machine_fe_status/info",

  MACHINE_ANALYSIS_REGISTERS:
    DASH_BACKEND_BASE_URL + "/api/geslub_dash/v1/machine_analysis",

  MACHINE_UNITIES_ANALYSIS_REGISTERS:
    DASH_BACKEND_BASE_URL + "/api/geslub_dash/v1/machine_lab_units",
};

export const AUTH_SERVICE_URLS = {
  USER: PLATFORM_BASE_URL + "/private/user",
};
